export default __webpack_public_path__ + "static/media/modal.62640cf5.png";